/** Valores por defecto de negocio (ajustar solo aquí si la marca cambia los textos). */
export const UTM_DEFAULT_SOURCE = "directo";
export const UTM_DEFAULT_MEDIUM = "landing_campaña";

export function readSessionItem(key) {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(key);
    if (raw == null) return null;
    const t = String(raw).trim();
    return t === "" ? null : t;
  } catch {
    return null;
  }
}

function normalizeParam(value) {
  if (value == null) return null;
  const t = String(value).trim();
  return t === "" ? null : t;
}

function getSearchString(search) {
  if (search !== undefined && search !== null) {
    if (typeof search === "string") return search;
    if (typeof search.toString === "function") return search.toString();
  }
  if (typeof window !== "undefined" && window.location && typeof window.location.search === "string") {
    return window.location.search;
  }
  return "";
}

/**
 * Resuelve utm_source y utm_medium desde la query actual (o `search` pasado), sessionStorage y defaults.
 * - Si ambos faltan en la URL → sessionStorage o defaults.
 * - Si al menos uno viene en la URL → el faltante se completa con sessionStorage o default.
 */
export function resolveUtmSourceAndMedium(search) {
  let params;
  try {
    params = new URLSearchParams(getSearchString(search));
  } catch {
    params = new URLSearchParams();
  }

  const fromUrl = {
    utm_source: normalizeParam(params.get("utm_source")),
    utm_medium: normalizeParam(params.get("utm_medium")),
  };

  const sessSource = readSessionItem("utm_source");
  const sessMedium = readSessionItem("utm_medium");

  if (!fromUrl.utm_source && !fromUrl.utm_medium) {
    return {
      utm_source: sessSource || UTM_DEFAULT_SOURCE,
      utm_medium: sessMedium || UTM_DEFAULT_MEDIUM,
    };
  }

  return {
    utm_source: fromUrl.utm_source || sessSource || UTM_DEFAULT_SOURCE,
    utm_medium: fromUrl.utm_medium || sessMedium || UTM_DEFAULT_MEDIUM,
  };
}

export function buildUtmSourceMediumQuery(search) {
  const { utm_source, utm_medium } = resolveUtmSourceAndMedium(search);
  return `?utm_source=${encodeURIComponent(utm_source)}&utm_medium=${encodeURIComponent(utm_medium)}`;
}
